/* eslint-disable no-param-reassign */
import { createSlice } from "@reduxjs/toolkit";
import dayjs from "dayjs";

// Default date window: current month up to today ("Month to date"), matching
// the app-wide DateRangeFilter THIS_MONTH convention. Computed at module load
// so the Reviews page defaults to MTD for both the social-review fetch and the
// export query (both read `dateRange` via buildTimestamp).
const monthToDateRange = () => ({
  startDate: dayjs().startOf("month").toISOString(),
  endDate: dayjs().endOf("day").toISOString(),
});

const initialFilters = {
  setPlatforms: true,
  platforms: [],
  users: [],
  dateRange: monthToDateRange(),
  rating: [],
  status: ["All"],
  isAiGenerated: false,
  // Show only reviews the reviewer has deleted (isDeleted flag on the query).
  isDeleted: false,
  // Selected ROOT opportunity_type ids (e.g. Sales/Service). Expanded to
  // root + descendant ids at query time before sending to the API.
  opportunityType: [],
};
const initialState = {
  filters: initialFilters,
};

const reviewSlice = createSlice({
  name: "reviewsSlice",
  initialState,
  reducers: {
    reducerSetPlatform(state, action) {
      state.filters.platforms = action.payload;
    },
    reducerSetPlatformsFlag(state, action) {
      state.filters.setPlatforms = action.payload;
    },
    reducerSetUsers(state, action) {
      state.filters.users = action.payload;
    },
    reducerSetDate(state, action) {
      state.filters.dateRange = action.payload;
    },
    reducerSetRating(state, action) {
      state.filters.rating = action.payload;
    },
    reducerSetStatus(state, action) {
      state.filters.status = action.payload;
    },
    reducerResetFilters(state, action) {
      state.filters = initialFilters;
    },
    reducerIsAiGenerated(state, action) {
      state.filters.isAiGenerated = action.payload;
    },
    reducerIsDeleted(state, action) {
      state.filters.isDeleted = action.payload;
    },
    reducerSetOpportunityType(state, action) {
      state.filters.opportunityType = action.payload;
    },
  },
});

export const {
  reducerSetPlatform,
  reducerSetUsers,
  reducerSetDate,
  reducerSetRating,
  reducerSetStatus,
  reducerResetFilters,
  reducerSetPlatformsFlag,
  reducerIsAiGenerated,
  reducerIsDeleted,
  reducerSetOpportunityType,
} = reviewSlice.actions;

export default reviewSlice.reducer;
